import { createAppBasePath } from '@beautyburst/tokens';

/**
 * Customer routes remain base-free (`/search`, `/orders/:id`) in route tables.
 * Use these helpers only at browser boundaries: hrefs, History API targets,
 * route matching inputs, and public asset URLs.
 */
export const customerBasePath = createAppBasePath(import.meta.env.BASE_URL, import.meta.url);
export const customerHref = (path: string): string => customerBasePath.prefix(path);
export const customerAsset = (path: string): string => customerBasePath.asset(path);
